import { lazy } from 'react';

export default lazy(() =>
  import(
    /* webpackChunkName: 'different_organization_page' */ './DifferentOrganizationPage'
  ),
);
